/***
 * Imports from Modules
 */
import "bootstrap";
import "datatables.net-dt/css/dataTables.dataTables.css";
import { Map, View } from "ol";
import { transform } from "ol/proj.js";
import { calculateTreeCo2Storage } from "./src/co2calculator.js";
import {
  getMapsAndOverlays,
  createLayerSwitcher,
  centerMap,
} from "./src/mapFunctions.js";
import { initMeasurementControls } from "./src/measureFunctions";
import { initializePopups } from "./src/popUpFunctions";
import { searchQuery } from "./src/searchFunctions";
import { checkInputFields } from "./src/helperFunctions";
import { treeclimateMap, setActualMap } from "./src/globalContext";
import { erstelleAccordionListener, updateLegend } from "./src/menuFunctions.js";
import { checkUserCookieStatus } from "./src/cookieFunctions.js";
import { initShadow } from "./src/shadowFunctions.js";
import { STATISTICS_URL } from "./src/config/api.js";
import { initializeBasicUserHelp } from "./src/basicUserHelpFunction";

// Phase-2-Module
import { initSearchEventHandler } from "./src/features/search/searchEventHandler.js";
import {
  initMapEventHandler,
  setLayerSwitcherEl,
} from "./src/features/map/mapEventHandler.js";
import { initUIEventHandler } from "./src/features/ui/uiEventHandler.js";

/***
 * Karte initialisieren
 */
const mapCenterCoordinates = transform(
  [6.85959, 49.55315],
  "EPSG:4326",
  "EPSG:3857"
);

var mapLayers = getMapsAndOverlays();
var mapView = new View({
  center: mapCenterCoordinates,
  zoom: 10,
});
var map = new Map({
  layers: mapLayers,
  target: document.getElementById("map"),
  view: mapView,
});

initShadow(map, { treeHeight: 10 });

// Durchmesser-Slider
const slider = document.getElementById("diameterRange");
const valueEl = document.getElementById("diameterValue");
const updateLabel = () => { valueEl.textContent = slider.value; };
slider.addEventListener("input", updateLabel);
updateLabel();

/***
 * App-Initialisierung (läuft nach vollständigem Seitenload)
 */
function initializeLegend() {
  const resolution = map.getView().getResolution();
  updateLegend(resolution);
  map.getView().on("change:resolution", function (event) {
    updateLegend(event.target.getResolution());
  });
}

function initializeMapLoadingSpinner() {
  const resolution = map.getView().getResolution();
  map.on("loadstart", function () {
    map.getTargetElement().classList.add("spinner");
    updateLegend(resolution);
  });
  map.on("loadend", function () {
    map.getTargetElement().classList.remove("spinner");
  });
}

function initTreeClimateDBApp() {
  // Globale Map-Instanz registrieren
  const actualMap = new treeclimateMap(map, mapView);
  setActualMap(actualMap);

  // Accordion-Menü
  erstelleAccordionListener();

  // Feature-Module initialisieren
  initSearchEventHandler(map);
  initMapEventHandler(map);
  initUIEventHandler();

  // Karten-Infrastruktur
  initializeMapLoadingSpinner();
  initializeLegend();
  initializePopups(map);
  initMeasurementControls(map);

  // Layer-Switcher
  const layerSwitcherControl = createLayerSwitcher();
  map.addControl(layerSwitcherControl);
  setLayerSwitcherEl(
    layerSwitcherControl.element ||
    document.querySelector(".ol-unselectable.ol-control.layer-switcher")
  );

  // Hilfesystem, sonstige Listener
  initializeBasicUserHelp();

  // Change-Listener Suchfeld
  document.getElementById("searchInputField").addEventListener("change", () => {
    checkInputFields();
  });

  // Karte zentrieren & Cookies prüfen
  centerMap(49.4039607, 6.9045054, 10);
  checkUserCookieStatus();

  // Initiale Suche
  searchQuery(true);

  // Statistik-Counter im Welcome-Modal
  $.getJSON(STATISTICS_URL, function (data) {
    const co2All = calculateTreeCo2Storage(data.GesamtMasse);
    $("#allTreesCount").html(data.TreeCount);
    $("#allCo2Count").html(parseInt(co2All));

    $(".count").each(function () {
      $(this).prop("Counter", 0).animate(
        { Counter: $(this).text() },
        {
          duration: 2000,
          easing: "swing",
          step: function (now) { $(this).text(Math.ceil(now)); },
        }
      );
    });
  });
}

$(window).on("load", function () {
  initTreeClimateDBApp();
});
